export const Services = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_293_24218)">
      <path
        d="M6.62025 14H0V7.58333C0 6.6185 0.785167 5.83333 1.75 5.83333H6.62025C6.20842 6.16642 5.84733 6.559 5.55217 7H1.75C1.42858 7 1.16667 7.26133 1.16667 7.58333V12.8333H5.55217C5.84733 13.2743 6.20842 13.6669 6.62025 14ZM10.5 0H3.5V1.16667H10.5V0ZM12.25 2.91667H1.75V4.08333H12.25V2.91667ZM14 9.91667C14 12.1677 12.1683 14 9.91667 14C7.665 14 5.83333 12.1677 5.83333 9.91667C5.83333 7.66558 7.665 5.83333 9.91667 5.83333C12.1683 5.83333 14 7.66558 14 9.91667ZM12.8333 9.91667C12.8333 8.30842 11.5249 7 9.91667 7C8.30842 7 7 8.30842 7 9.91667C7 11.5249 8.30842 12.8333 9.91667 12.8333C11.5249 12.8333 12.8333 11.5249 12.8333 9.91667ZM10.5 8.16667H9.33333V9.33333H8.16667V10.5H9.33333V11.6667H10.5V10.5H11.6667V9.33333H10.5V8.16667Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_293_24218">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
